import { Component, Prop, Vue } from 'vue-property-decorator';
import { accessibleTicketGroupColor } from '@tix/themes/helpers';
import { getAccessibilityType } from '@/helpers/TicketGroupHelpers';
import { getTicketGroupColor } from '../../helpers/TicketGroupsColors';
@Component({ name: 'TicketGroupSeatBadge' })
export default class default_1 extends Vue {
    @Prop({ required: true })
    ticketGroup;
    iconsMap = {
        wheelchair: 'WheelchairIcon',
        companion: 'CompanionIcon',
        'semi-ambulatory': 'AisleTransferIcon',
    };
    get isAccessible() {
        return this.ticketGroup.isAccessible ?? false;
    }
    get accessibilityType() {
        return getAccessibilityType(this.ticketGroup);
    }
    get style() {
        return {
            '--tg-color': this.isAccessible ? accessibleTicketGroupColor : getTicketGroupColor(this.ticketGroup),
        };
    }
}
